import * as yup from 'yup'

import i18n from '../i18n'

export const PasswordLoginInputSchema = yup.object().shape({
  password: yup.string().required(i18n.t('auth.shared.validation.passwordRequired') || ''),
})
